<template>
  <div>
  
    <preview-new-course-component :PreviewEditCouseImages="PreviewImg"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PreviewNewCourseComponent from '../../components/Courses/PreviewNewCourse.component.vue'
export default {
  components: {PreviewNewCourseComponent },
  computed:{
    ...mapGetters(["GetPreviewCourse"])
  },
  data() {
    return {
      PreviewImg: {
        showBannerInPreview: "",
        showThumbnailInPreview: "",
        showImg1InPreview: "",
        showImg2InPreview: "",
        showImg3InPreview: "",
      },
    }
  },
  mounted(){
    this.PreviewImg.showBannerInPreview = this.GetPreviewCourse.Banner;
    this.PreviewImg.showThumbnailInPreview = this.GetPreviewCourse.Thumbnail;
    this.PreviewImg.showImg1InPreview = this.GetPreviewCourse.Image1;
    this.PreviewImg.showImg2InPreview = this.GetPreviewCourse.Image2;
    this.PreviewImg.showImg3InPreview = this.GetPreviewCourse.Image3;
  }

}
</script>